<script setup lang="ts">
import { TabsList, useForwardPropsEmits } from 'radix-vue'
import type { TabsListProps } from 'radix-vue'

const props = defineProps<TabsListProps>()

const forwarded = useForwardPropsEmits(props)
</script>

<template>
  <TabsList v-bind="forwarded" :class="$style.list">
    <slot />
  </TabsList>
</template>

<style lang="scss" module>
.list {
  display: flex;
  border-bottom: 1px solid $color-border-low-emphasis;
  position: relative;
}
</style>
